import React, { useState } from "react";
import ProductCard from "./ProductCard";

const PAGE_SIZE = 8;

export default function ProductGrid({ title, products, cols = "col-6 col-lg-3" }) {
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
  const visibleProducts = products.slice(0, visibleCount);
  const hasMore = visibleCount < products.length;

  return (
    <section className="mu-section pt-0">
      <div className="container">
        {title && <h2 className="section-title mb-4">{title}</h2>}

        <div className="row g-4">
          {visibleProducts.map((p) => (
            <div className={cols} key={p.slug}>
              <ProductCard product={p} />
            </div>
          ))}
        </div>

        {hasMore && (
          <div className="text-center mt-5">
            <button className="btn-mu-outline" onClick={() => setVisibleCount((c) => c + PAGE_SIZE)}>
              Load More Products
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
